import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    user: '',
    permissions: '',
    modules: '',
}

const mutations = {
    SET_USER_DATA: (state, data) => {
        state.user = data;
    },
    SET_MODULES_DATA: (state, data) => {
        state.modules = data;
    },
    SET_PERMISSIONS_DATA: (state, data) => {
        state.permissions = data;
    },
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
        state[variable] = value
    }
}

export default new Vuex.Store({
    state,
    mutations
})